export interface AppState {}

export const initialState: AppState = {};
